import { FullStory as FS } from '@fullstory/browser';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const FullStory: FC = () => {
  const therapistData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data
  );

  const [identified, setIdentified] = useState(false);
  const [currentUserId, setCurrentUserId] = useState<string | null>(null);

  useEffect(() => {
    // If user logged out or changed, clear identity
    if (!therapistData?.firstName && identified) {
      FS('setIdentity', { anonymous: true });
      setIdentified(false);
      setCurrentUserId(null);
      return;
    }

    // If a different user is logging in, clear previous identity first
    if (therapistData?.uuid && currentUserId && currentUserId !== therapistData.uuid) {
      FS('setIdentity', { anonymous: true });
      setIdentified(false);
    }

    // Identify the current user
    if (therapistData?.firstName && therapistData?.uuid && !identified) {
      FS('setIdentity', {
        uid: therapistData.uuid,
        properties: {
          displayName: `${therapistData.firstName} ${therapistData.lastName}`,
          email: therapistData.email,
        },
      });
      setIdentified(true);
      setCurrentUserId(therapistData.uuid);
    }
  }, [therapistData, identified, currentUserId]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (identified) {
        FS('setIdentity', { anonymous: true });
      }
    };
  }, [identified]);

  return null;
};

export default FullStory;
